// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QFZyb","signatureBlock":"Footer_signatureBlock__Esn8h","signature":"Footer_signature__BtVx5"};